import React from "react";

const AppContext = React.createContext({
  statesData: [],
  userSaves: [],
  allStates: [],
  saveData: [],
  stateResults: [],
  newSaveName: null,
  isAuthenticated: false,
  saveName: null,
  email: null,
  user_name: null,
  password: null,
  selectedStates: [],
  currentSaveResults: [],
  navbarToggle: false,
  type: null,
  message: null,
  right: -500,
  NavBarToggle: () => {},
  runSaveSearch: () => {},
  updateSaveName: () => {},
  deleteSave: () => {},
  saveSearch: () => {},
  setSaveName: () => {},
  loginUser: () => {},
  createAccount: () => {},
  fetchFips: () => {},
  handleStateSelection: () => {},
  setName: () => {},
  setPassword: () => {},
  setEmail: () => {},
  logout: () => {},
});

export default AppContext;
